import { forwardRef } from 'react';
import { jsxs, jsx } from 'react/jsx-runtime';

const SvgDownload = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/jsxs("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 60 60",
    width: "1em",
    height: "1em",
    ref: ref,
    "aria-labelledby": titleId,
    ...props,
    children: [title ? /*#__PURE__*/jsx("title", {
      id: titleId,
      children: title
    }) : null, /*#__PURE__*/jsx("path", {
      d: "M6.5 51.998h47v5h-47zm43.598-21.905-3.536-3.531-13.853 13.86V3.002h-4.996v37.443L13.63 26.416l-3.532 3.533 20.106 20.053z",
      fill: "currentColor"
    })]
  });
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgDownload);
var ForwardRef$1 = ForwardRef;

export { ForwardRef$1 as default };
